import { render, staticRenderFns } from "./QAstatus.vue?vue&type=template&id=bd8f8648&"
import script from "./QAstatus.vue?vue&type=script&lang=js&"
export * from "./QAstatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports